module.exports = __webpack_public_path__ + "static/helga-3c356a53d3c4429923a48fcd662f900f.png";